import script from "./InquiryFormEmbed.vue?vue&type=script&setup=true&lang=ts"
export * from "./InquiryFormEmbed.vue?vue&type=script&setup=true&lang=ts"

import "./InquiryFormEmbed.vue?vue&type=style&index=0&id=70882d76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70882d76"]])

export default __exports__